var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<label class=\"avant-garde-form-label\">Preview</label><div class=\"settings-gallery-intro__preview js-settings-gallery-intro__preview\"></div>");;return buf.join("");
};
module.exports = template;